import { type ComponentProps } from 'react';

import { Player } from '@cartwhl/3d/player';

import { useCartographerFbxMeshOptions } from '../useCartographerFbxMeshOptions';

type PlayerCharacterProps = ComponentProps<typeof Player.Character>;

export interface CartographerPreviewCharacterProps
  extends PlayerCharacterProps {
  meshFile?: File | null;
}

export default function CartographerPreviewCharacter({
  meshFile = null,
  meshFormat,
  meshPath,
  ...props
}: CartographerPreviewCharacterProps) {
  const { meshFormat: resolvedMeshFormat, loadFBX, transformLoadedMesh } =
    useCartographerFbxMeshOptions({
      meshPath,
      meshFormat,
      meshFile,
      enableDebugEvents: true,
    });

  return (
    <Player.Character
      {...props}
      meshPath={meshPath}
      meshFormat={resolvedMeshFormat}
      transformLoadedMesh={transformLoadedMesh}
      loadFBX={loadFBX}
    />
  );
}
